import axios, { AxiosRequestConfig, AxiosResponse } from "axios";
import {
  ApiResponse,
  GenericObjectInterface,
} from "../commonInterface/commonInterface";

// Endpoints that should include status=draft in staging environment
const STAGING_DRAFT_ENDPOINTS: string[] = [
  'api/vendors',
  'api/vendors-by-id',
  'api/products',
  'api/products-by-category',
  'api/rss-feeds',
  'api/main-categories',
  'api/rss-feeds-by-subcategory',
  'api/rss-feeds-by-category',
  'api/articles',
  'api/articles-by-subcategory',
  'api/topics',
  'api/topics/topics-by-subcategory',
];

/**
 * Checks if the current environment is staging
 */
const isStaging = (): boolean => {
  return process.env.NEXT_PUBLIC_APP_ENV === 'staging';
};

/**
 * Checks if an endpoint should have draft status appended in staging
 */
const shouldAppendDraftStatus = (endpoint: string): boolean => {
  const endpointBase = endpoint.split('?')[0];

  return STAGING_DRAFT_ENDPOINTS.some(stagingEndpoint => {
    return endpointBase === stagingEndpoint ||
      endpointBase.startsWith(stagingEndpoint + '/');
  });
};

/**
 * Appends status=draft parameter to URL if in staging environment
 */
const appendDraftStatus = (endpoint: string): string => {
  if (!isStaging() || !shouldAppendDraftStatus(endpoint)) {
    return endpoint;
  }

  // Don't append if status param already exists
  if (endpoint.includes('status=')) {
    return endpoint;
  }

  const separator = endpoint.includes('?') ? '&' : '?';
  return `${endpoint}${separator}status=draft`;
};

export let BASE_URL = "https://backend.aimsintel.com/";

const appEnv = process.env.NEXT_PUBLIC_APP_ENV;

console.log(appEnv, " Environment");


if (appEnv === 'production' || appEnv === 'staging') {
  BASE_URL = "https://backend.aimsintel.com/";
  // BASE_URL = "http://localhost:1337/";
} else if (appEnv === 'development') {
  BASE_URL = "https://api.aimsintel.com/";
} else {
  // BASE_URL = "https://api.aimsintel.com/";
  BASE_URL = "http://localhost:1337/";
}
export const headersList = {
  Accept: "*/*",
  "Content-Type": "application/json",
};

export const API_ENDPOINTS: GenericObjectInterface = {
  SIGNUP: `api/auth/local/register`,
  LOGIN: 'api/auth/local/',
  FORGOT_PASSWORD: 'api/auth/forgot-password',
  RESET_PASSWORD: 'api/auth/reset-password',
  PRODUCT_CATEGORIES: `api/categories`,
  ALL_CATEGORIES: `api/main-categories`,
  SINGEL_PRODUCT: `api/products`,
  PRODUCT_BY_SLUG: `api/products/slug`,
  PRODUCTS: `api/products`,
  COMPARE_PRODUCTS: `api/compare-products`,
  COMPARE_FEATURES: `api/comparison-features`,
  PRODUCT_COMPARISON: `api/compare-products`,
  SIMILAR_PRODUCTS: `api/similar-products-by-category/`,
  RSS_FEED: `api/rss-feeds`,
  RSS_FEED_BY_SUBCATEGORY: `api/rss-feeds-by-subcategory`,
  RSS_FEED_BY_CATEGORY: `api/rss-feeds-by-category`,
  BLOGS_DETAILS: `api/articles`,
  BLOGS_DETAILS_BY_SUBCATEGORY: `api/articles-by-subcategory`,
  BLOGS: `api/articles?populate=*`,
  SEARCH_PRODUCTS: 'api/autosearches',
  SUBSCRIBE_NEWSLETTERS: 'api/subscriptions',
  NEWSLETTERS: 'api/newsletters',
  WHITEPAPERS: 'api/resources',
  GET_PRODUCTS_BY_CATEGORY: 'api/products-by-category',
  VENDOR_CATEGORIES: 'api/vendor-main-categories',
  VENDORS: 'api/vendors',
  VENDORS_BY_SUBCATEGORY: 'api/vendors-by-id',
  FAQ: 'api/topics',
  FAQ_BY_SUBCATEGORY: 'api/topics/topics-by-subcategory',
  ARTICLE_FEEDBACK: 'api/articles/feedback',
  NEWSLETTER_FEEDBACK: 'api/newsletters/feedback',
  FAQ_FEEDBACK: 'api/topics/feedback',
  VENDOR_FEEDBACK: 'api/vendors/feedback',
  PRODUCT_FEEDBACK: 'api/products/feedback',
  INQUIRY: 'api/product-inquiries',
  WEBINAR_VIDEOS: 'api/webinars',
  WEBINAR_VIDEOS_BY_SUBCATEGORY: 'api/webinars-by-subcategory',
  INFOGRAPHICS: 'api/infographics',
  INFOGRAPHICS_DETAILS: 'api/infographics',
  INFOGRAPHICS_BY_SUBCATEGORY: 'api/infographics-by-subcategory',
  INTERVIEW_PODCASTS: 'api/interviews-podcasts',
  INTEVIEW_PODCASTS_BY_SUBCATEGORY: 'api/interviews-podcasts-by-subcategory',
  WHITEPAPERS_BY_SUBCATEGORY: 'api/resources-by-subcategory',
  CASE_STUDIES_BY_SUBCATEGORY: 'api/resources-by-subcategory',
};

export const makeApiRequest = async <T>(
  method: AxiosRequestConfig["method"],
  endpoint: string,
  data: any = null,
  customHeaders: GenericObjectInterface
): Promise<ApiResponse<T>> => {
  try {
    const processedEndpoint = appendDraftStatus(endpoint);
    const url = `${BASE_URL}${processedEndpoint}`;
    const response: AxiosResponse<T> = await axios({
      method,
      url,
      data,
      headers: customHeaders,
    });
    return {
      data: response.data,
      status: response.status,
    };
  } catch (error) {
    throw error;
  }
};
